import { Page, View, Text, Image } from '@react-pdf/renderer';
import { styles } from './styles';
import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { useTranslation } from 'react-i18next';

export interface CommunityFeedbackPageProps {
  event: PublicEventDetailsResponse;
  footer: JSX.Element;
}

const TextSection = ({
  citation,
  text1,
  text2,
  text3 = '',
}: {
  citation: string;
  text1: string;
  text2: string;
  text3?: string | undefined;
}) => {
  return (
    <View style={styles.textWrapper}>
      <Text style={styles.title}>{citation}</Text>

      <Text style={styles.subtitle}>{text1}</Text>
      <Text style={styles.subtitle}>{text2}</Text>
      {text3 && <Text style={styles.subtitle}>{text3}</Text>}
    </View>
  );
};

const CommunityFeedbackPage = ({
  event,
  footer,
}: CommunityFeedbackPageProps) => {
  const { t, i18n } = useTranslation();

  return (
    <Page
      size={{ width: 1440, height: 800 }}
      style={{
        ...styles.page,
        backgroundColor: event?.design?.themeColor,
        color: 'white',
      }}
    >
      <View
        style={{
          ...styles.columnContainer,
        }}
      >
        <View style={styles.leftColumn}>
          <Image
            src={
              'https://media.we-conect.com/images/pdf/partnerprospectus/10_1.png'
            }
            style={styles.leftBigImage}
          />

          <TextSection
            citation={t('community-feedback-item-1-citation')}
            text1={t('community-feedback-item-1-text1')}
            text2={t('community-feedback-item-1-text2')}
            text3={t('community-feedback-item-1-text3')}
          />

          <Image
            src={
              'https://media.we-conect.com/images/pdf/partnerprospectus/10_5.png'
            }
            style={styles.leftSmallImage}
          />
        </View>

        <View style={styles.middleColumn}>
          <View style={styles.middleColumnRow1}>
            <TextSection
              citation={t('community-feedback-item-2-citation')}
              text1={t('community-feedback-item-2-text1')}
              text2={t('community-feedback-item-2-text2')}
              text3={t('community-feedback-item-2-text3')}
            />

            <TextSection
              citation={t('community-feedback-item-3-citation')}
              text1={t('community-feedback-item-3-text1')}
              text2={t('community-feedback-item-3-text2')}
            />
          </View>

          <Image
            src={
              'https://media.we-conect.com/images/pdf/partnerprospectus/10_2.png'
            }
            style={styles.middleColumnBigImage}
          />

          <View style={styles.middleColumnRow1}>
            <TextSection
              citation={t('community-feedback-item-4-citation')}
              text1={t('community-feedback-item-4-text1')}
              text2={t('community-feedback-item-4-text2')}
            />

            <Image
              src={
                'https://media.we-conect.com/images/pdf/partnerprospectus/10_6.png'
              }
              style={styles.leftSmallImage}
            />
          </View>
        </View>

        <View style={styles.rightColumn}>
          <View style={styles.rightColumnWrapper}>
            <View style={styles.columnWrapper}>
              <Image
                src={
                  'https://media.we-conect.com/images/pdf/partnerprospectus/10_3.png'
                }
                style={styles.rightColumnLeftImage}
              />

              <TextSection
                citation={t('community-feedback-item-6-citation')}
                text1={t('community-feedback-item-6-text1')}
                text2={t('community-feedback-item-6-text2')}
              />
              <TextSection
                citation={t('community-feedback-item-7-citation')}
                text1={t('community-feedback-item-7-text1')}
                text2={t('community-feedback-item-7-text2')}
                text3={t('community-feedback-item-7-text3')}
              />
            </View>

            <View style={styles.columnWrapper}>
              <TextSection
                citation={t('community-feedback-item-5-citation')}
                text1={t('community-feedback-item-5-text1')}
                text2={t('community-feedback-item-5-text2')}
              />

              <Image
                src={
                  'https://media.we-conect.com/images/pdf/partnerprospectus/10_4.png'
                }
                style={styles.rightColumnRightImage}
              />
            </View>
          </View>
        </View>
      </View>
      {footer}
    </Page>
  );
};

export default CommunityFeedbackPage;
